import { FunctionComponent, useContext } from 'react'
import styled, { ThemeContext } from 'styled-components'

import PhotoIcon from 'components/SVG/Photo'

import Spacer from './Spacer'

interface INoPhotoProps {
  cursor?: string
  borderRadius?: number
  topRadius?: number
  height?: number
  tabletHeight?: number
  desktopHeight?: number
  maxWidth?: number
}

const Container = styled.div<INoPhotoProps>`
  position: relative;
  width: 100%;
  background: ${props => props.theme.colors.transparentPurpleAlpha12};
  user-select: none;
  ${props => props.maxWidth && `max-width: ${props.maxWidth}px;`}
  ${props => props.height && `height: ${props.height}px;`}
  ${props => props.borderRadius && `border-radius: ${props.borderRadius}px;`}
  ${props => props.topRadius && `border-top-left-radius: ${props.topRadius}px;`}
  ${props => props.topRadius && `border-top-right-radius: ${props.topRadius}px;`}
  ${props => props.cursor && `cursor: ${props.cursor};`}

  @media(min-width: ${props => props.theme.metrics.tablet}px) {
    ${props => props.tabletHeight && `height: ${props.tabletHeight}px;`}
  }

  @media (min-width: ${props => props.theme.metrics.desktop}px) {
    ${props => props.desktopHeight && `height: ${props.desktopHeight}px;`}
  }
`

const IconContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
`

interface IProps {
  cursor?: string
  borderRadius?: number
  topRadius?: number
  showText?: boolean
  text?: string
  height?: number
  tabletHeight?: number
  desktopHeight?: number
  maxWidth?: number
}

const NoPhoto: FunctionComponent<IProps> = ({
  children,
  cursor,
  borderRadius,
  topRadius,
  showText,
  text,
  height,
  tabletHeight,
  desktopHeight,
  maxWidth,
}) => {
  const theme = useContext(ThemeContext)

  return (
    <Container
      borderRadius={borderRadius}
      topRadius={topRadius}
      cursor={cursor}
      height={height}
      tabletHeight={tabletHeight}
      desktopHeight={desktopHeight}
      maxWidth={maxWidth}
    >
      <IconContainer>
        <PhotoIcon
          width={82}
          height={66}
          fill={theme.colors.transparentPurpleAlpha25}
        />
        {showText && <Spacer size={16} />}
        {showText && (text || 'No Photos Added')}
      </IconContainer>
      {children}
    </Container>
  )
}

export default NoPhoto
